import Vue from 'vue'
import BootstrapVue from "bootstrap-vue"
import App from './App.vue'
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap-vue/dist/bootstrap-vue.css"
import VueRouter from 'vue-router'
import Tarifs from './Tarifs.vue'
import Main from './Main.vue'
import News from './News.vue'
import About from './About.vue'
import Vats from './Vats.vue'
import Login from './Login.vue'

Vue.use(VueRouter);
Vue.use(BootstrapVue)

// компоненты, которые обрабатывают пути
const NotFound = {template: '<h1>404 NOT FOUND</h1>'}
const Home = { template: '<h2>Home Page</h2>' }

 
// маршруты, сопотавленные с компонентами
const routes = [
  { path: '/',redirect: '/main'  },
  { path: '/main', component: Main },
  { path: '/about', component: About },
  { path: '/tarifs',component: Tarifs},
  { path: '/news',component: News},
  { path: '/vats',component: Vats},
  { path: '/login',component: Login}
];
// создаем объект маршрутизатора
const router = new VueRouter({
    mode: 'history',
    routes: routes
});


// new Vue({
//   el: '#app',
//   render: h => h(App)
// })

const app = new Vue({
  router,
  render: h => h(App)
}).$mount('#app')


// WEBPACK FOOTER //
// ./src/main.js